import mori from 'mori';

/**
 * Get active locations or false for all
 * @param  {mori.vector} locations [locations from combinedFilters[0]]
 * @return {mori.vector || false}  [active locations]
 */
export default function getLocations(locations) {
  return mori.count(locations) > 0 ?
    mori.map((item) => {
      return mori.first(
        mori.vals(
          mori.count(item) > 1 ? mori.first(item) : item
        )
      );
    }, mori.flatten(locations)) :
    false;
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/services/getFootnotes/getLocations.js